import axiosClient from "../axiosClient";

export const S3FileUpload = async (file, config) => {
    return await axiosClient.post('/upload_file_S3', file, config);
};

export const S3ZipUpload = async (data, config) => {
    return await axiosClient.post('upload_zip_S3', data, config);
};

export const deleteFile = async (data) => {
    return await axiosClient.post('delete_file', data);
};

/** pre-college */

export const S3FileUploadPost = async (file, config) => {
    return await axiosClient.post('/preclg_upload_image_cms', file, config);
};